<template>
  <div>
    <div class="serviceDiv">
      <div>
        <a href="https://chat.ssrchat.com/service/gqd921">
          <img src="@/assets/images/recruit/service.png" class="serviceImg1" />
          <div class="imgParent">
            <img
              src="@/assets/images/recruit/serviceBg.png"
              class="serviceImg2"
            />
            <div class="serviceText">{{ textObj[lang].onlineService }}</div>
          </div>
        </a>
        <div class="serviceBox">
          <!-- <div class="serviceItem">
            <img
              src="@/assets/images/recruit/phone_white.png"
              class="serviceIcon"
            />
            <div class="serviceTitle">phone</div>
            <div class="serviceDesc">
              <div class="phoneTextTitle">phone</div>
              <div class="phoneTextNum">0921929291</div>
            </div>
          </div> -->
          <div class="serviceItem" @click="showModal('Email')">
            <img
              src="@/assets/images/recruit/email_white.png"
              class="serviceIcon"
            />
            <div class="serviceTitle">email</div>
            <div class="serviceDesc pcShow">
              <div class="phoneTextTitle">email</div>
              <div class="phoneTextNum">{{ configData.email }}</div>
            </div>
          </div>
          <div
            class="serviceItem"
            style="margin-bottom: 0"
            @click="showModal('Zalo')"
          >
            <img
              src="@/assets/images/recruit/zalo_white.png"
              class="serviceIcon"
            />
            <div class="serviceTitle">zalo</div>
            <div class="serviceDesc pcShow">
              <div class="phoneTextTitle">zalo</div>
              <div class="phoneTextNum">{{ configData.zalo }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      src="@/assets/images/recruit/download2.png"
      class="downloadImg2 mobileShow"
      @click="goDownload"
    />

    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      width="80%"
      center
      :show-close="false"
      top="40vh"
      custom-class="dialogClass"
    >
      <div class="dialogText">
        {{ title == "Email" ? configData.email : configData.zalo }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" class="serviceBtn"
          >Cancel</el-button
        >
        <el-button type="primary" @click="copyFun" class="serviceBtn"
          >Copy</el-button
        >
      </span>
    </el-dialog>
    <textarea class="demoText"">{{
      title == "Email" ? configData.email : configData.zalo
    }}</textarea>
  </div>
</template>
<script>
export default {
  name: "recruitDetail",
  data() {
    return {
      centerDialogVisible: false,
      title: "Email",
      textObj: {
        en: {
          onlineService: "Live Chat",
        },
        vi: {
          onlineService: "Liên hệ",
        },
      },
      lang: "en",
      active: 0,
      downloadUrl: {
        android:
          "https://play.google.com/store/apps/details?id=com.kaigongdajibs.app",
        ios: "https://apps.apple.com/us/app/yame-b%C3%BAt-k%C3%AD-x%C3%A3-h%E1%BB%99i/id6742023134?l=zh-Hans-CN",
      },
      configData: {
        email: "YAME669@gmail.com",
        zalo: "0921929291",
      },
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  created() {
    this.init();
  },
  methods: {
    showModal(title) {
      if (!this.isMobile) {
        return;
      }
      this.title = title;
      this.centerDialogVisible = true;
    },
    copyFun() {
      let copyText = document.querySelector(".demoText");
      copyText.select();
      document.execCommand("copy");
      this.centerDialogVisible = false;
      this.$message({
        message: "Copy Success",
        type: "success",
      });
    },
    goDownload() {
      /// 判断是安卓还是苹果
      let url = navigator.userAgent.match(/(Android)/)
        ? this.downloadUrl.android
        : this.downloadUrl.ios;
      window.open(url);
    },
    init() {
      this.lang = localStorage.getItem("lang") || "en";
    },
  },
};
</script>

<style scoped>
.mobileShow {
  display: none !important;
  @media screen and (max-width: 768px) {
    display: block !important;
  }
}
.pcShow {
  /* display: block !important; */
  visibility: visible !important;
  @media screen and (max-width: 768px) {
    visibility: hidden !important;
  }
}
.serviceDiv {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 999;
}
.serviceDiv a {
  text-decoration: none;
  display: block;
  position: relative;
}
.imgParent {
  position: absolute;
  bottom: -10px;
  left: 4.5px;
  z-index: 10;
}
@keyframes pulse-circle {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.8);
  }
}
.pulse-circle {
  position: absolute;
  top: 0;
  border: 1px solid #579bff;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  animation: pulse-circle 2s infinite ease-in-out;
}
.serviceImg1 {
  width: 76px;
  height: 76px;
  animation: pulse-circle 2s infinite ease-in-out;
  display: block;
}
.serviceImg2 {
  display: block;
  width: 67px;
  height: 26px;
  margin: -15px auto 0;
}
.serviceText {
  margin-top: -21px;
  color: #fff;
  font-size: 11px;
  text-align: center;
}
.serviceBox {
  margin: 27px auto 0;
  position: relative;
  width: 67px;
  /* height: 180px; */
  height: 123px;
  border-radius: 10px;
  background: url("../assets/images/recruit/rightBg.png") no-repeat;
  z-index: 2;
}
.serviceItem {
  padding-top: 9px;
  position: relative;
  margin-bottom: 4px;
  cursor: pointer;
}
.serviceItem:hover {
  > .serviceDesc {
    display: block;
  }
}
.serviceIcon {
  display: block;
  margin: 0 auto 2px;
  width: 28px;
}
.serviceTitle {
  color: #fff;
  text-align: center;
  font-size: 11px;
}
.serviceDesc {
  display: none;
  position: absolute;
  right: 75px;
  top: 0;
  min-width: 106px;
  background-color: #fff;
  height: 44px;
  border-radius: 2px;
  padding: 4px 7px;
}
.phoneTextTitle {
  font-size: 12px;
}
.phoneTextNum {
  font-size: 12px;
  margin-top: 5px;
  color: #ff5732;
}
.downloadImg2 {
  width: calc(100% - 40px);
  left: 20px;
  right: 20px;
  position: fixed;
  bottom: 20px;
  z-index: 999;
}
.dialogText {
  font-size: 14px;
  color: #646566;
  text-align: center;
}
.serviceBtn {
  border-radius: 12px;
  width: 100px;
}
.demoText {
  opacity: 0;
  position: absolute;
  bottom: 0;
}
</style>
<style>
.dialogClass {
  border-radius: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OnlineService.vue